import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';

interface SignatureSavedModalProps {
  show: boolean;
  handleClose: () => void;
}

const SignatureSavedModal: React.FC<SignatureSavedModalProps> = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Body style={{ padding: "32px 24px", textAlign: "center" }}>

        <FaCheckCircle style={{ fontSize: "3.5rem", color: "#16a34a", marginBottom: "16px" }} />

        <h3 style={{ fontSize: "1.25rem", fontWeight: 700, color: "#0f1c34", marginBottom: "8px" }}>
          Signature Captured
        </h3>

        <p style={{ color: "#6B7280", fontSize: "0.95rem", marginBottom: "24px", lineHeight: 1.5 }}>
          The signature has been securely saved to the report. You can clear and re-take it if necessary.
        </p>

        <button
          onClick={handleClose}
          className="au-submit-btn hover-trigger"
          style={{
            width: "100%",
            padding: "12px",
            background: "linear-gradient(135deg, #2563C0 0%, #1d4ed8 100%)",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            fontWeight: 600,
            fontSize: "1rem",
            boxShadow: "0 4px 12px rgba(37,99,192,0.3)"
          }}
        >
          Continue
        </button>

      </Modal.Body>
    </Modal>
  );
};

export default SignatureSavedModal;
